import { dispatcher, api } from '@unicus/react-ui-kit';

export const PACKAGE = 'PACKAGE';

export const PACKAGE_FETCH = 'PACKAGE_FETCH';
export const PACKAGE_FETCH_FINISHED = 'PACKAGE_FETCH_FINISHED';

export const fetch = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'packages',
    actionType: PACKAGE_FETCH,
    effect: async () => api.fetch('packages/without-pagination', params)
  });
};
